import { Box, ButtonBase, makeStyles } from "@material-ui/core";
import React, { useCallback, useEffect, useRef, useState } from "react";

// import CozuchiBanner from "../../../../assets/image/news_banner_cozuchi.png";
import { layoutTokens, semanticColors } from "@/designTokens";
import { useDevice } from "@/hooks/useDevice";

import GuidePcBanner from "@assets/image/home_banner_guide_pc_v2.webp";
import GuideBanner from "@assets/image/home_banner_guide_v2.webp";
import MsinsPcBanner from "@assets/image/home_banner_msins_pc_v2.webp";
import MsinsBanner from "@assets/image/home_banner_msins_v2.webp";
import SecondOpinionPcBanner from "@assets/image/home_banner_second_opinion_pc_v2.webp";
import SecondOpinionBanner from "@assets/image/home_banner_second_opinion_v2.webp";
import SmaulPcBanner from "@assets/image/home_banner_smaul_pc_v2.webp";
import SmaulBanner from "@assets/image/home_banner_smaul_v2.webp";
// import TaxReturnBanner from "../../../../assets/image/news_banner_tax_return.png";
// import WebinarBanner from "../../../../assets/image/news_banner_webinar.png";

const useStyles = makeStyles(() => ({
  scrollContainer: {
    display: "flex",
    overflowX: "auto",
    overflowY: "hidden",
    scrollSnapType: "x mandatory",
    WebkitOverflowScrolling: "touch",
    scrollbarWidth: "none",
    touchAction: "pan-x pan-y",
    overscrollBehaviorY: "contain",
    position: "relative",
    gap: layoutTokens.space[12],
    backgroundColor: "transparent",
    "&": {
      overflowX: "auto !important", // ← Reactによる style="overflow: initial" を打ち消す
    },
  },
  spRail: { marginRight: -layoutTokens.space[24], paddingRight: layoutTokens.space[24] },
  pcRail: { "& > *": { width: "100%" } },
  dots: { display: "flex", justifyContent: "center", gap: layoutTokens.space[4], marginTop: layoutTokens.space[8] },
  dotButton: { minWidth: 32, minHeight: 44 },
  dot: { width: 6, height: 6, borderRadius: layoutTokens.radius.full, backgroundColor: semanticColors["icon/muted"] },
  activeDot: { backgroundColor: semanticColors["icon/primary"] },
  bannerItem: {
    scrollSnapAlign: "start",
    flexShrink: 0,
    width: 280,
    boxSizing: "border-box",
  },
  banner: {
    cursor: "pointer",
    width: "100%",
    aspectRatio: "280 / 160",
    position: "relative",
    overflow: "hidden",
    borderRadius: layoutTokens.radius.lg,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  image: {
    // Figma の書き出し（SP は2倍・PC は3倍。転送量を抑えるため WebP）が含む外側 8px 相当の影だけを表示領域の外に置く。
    position: "absolute",
    width: "105.714286%",
    height: "110%",
    left: "-2.857143%",
    top: "-5%",
    objectFit: "fill",
    display: "block",
    borderRadius: layoutTokens.radius.lg,
  },
}));

type BannerRenderArgs = {
  isMobile: boolean;
  tabIndex: number;
  classes: Record<string, string>;
  onPaypayClick: () => void;
  onSecondOpinionClick: () => void;
  onGuideClick: () => void;
  onMsinsClick: () => void;
  onSmaulClick: () => void;
  onTaxReturnClick: () => void;
  onWebinarClick: () => void;
  onCozuchiClick: () => void;
};

type BannerRender = (args: BannerRenderArgs) => React.ReactNode;

const banners: { id: string; render: BannerRender }[] = [
  // COZUCHIキャンペーンバナー
  // {
  //   id: "cozuchi",
  //   render: ({ classes, onCozuchiClick }) => (
  //     <Box onClick={onCozuchiClick} className={classes.banner}>
  //       <img className={`${classes.image} ${isMobile ? "" : classes.pcImage}`} src={CozuchiBanner} alt="COZUCHIキャンペーン" />
  //     </Box>
  //   ),
  // },
  // 確定申告サポート機能バナー
  // {
  //   id: "tax_return",
  //   render: ({ classes, onTaxReturnClick }) => (
  //     <Box onClick={onTaxReturnClick} className={classes.banner}>
  //       <img className={`${classes.image} ${isMobile ? "" : classes.pcImage}`} src={TaxReturnBanner} alt="確定申告サポート機能" />
  //     </Box>
  //   ),
  // },
  // セカンドオピニオンバナー
  {
    id: "second_opinion",
    render: ({ classes, isMobile, tabIndex, onSecondOpinionClick }) => (
      <ButtonBase tabIndex={tabIndex} onClick={onSecondOpinionClick} className={classes.banner}>
        <img
          className={classes.image}
          src={isMobile ? SecondOpinionBanner : SecondOpinionPcBanner}
          alt="セカンドオピニオン"
        />
      </ButtonBase>
    ),
  },
  // ガイドバナー
  {
    id: "guide",
    render: ({ classes, isMobile, tabIndex, onGuideClick }) => (
      <ButtonBase tabIndex={tabIndex} onClick={onGuideClick} className={classes.banner}>
        <img
          className={classes.image}
          src={isMobile ? GuideBanner : GuidePcBanner}
          alt="ガイド"
        />
      </ButtonBase>
    ),
  },
  // Msins 検討者向けバナー
  {
    id: "msins",
    render: ({ classes, isMobile, tabIndex, onMsinsClick }) => (
      <ButtonBase tabIndex={tabIndex} onClick={onMsinsClick} className={classes.banner}>
        <img
          className={classes.image}
          src={isMobile ? MsinsBanner : MsinsPcBanner}
          alt="Msins"
        />
      </ButtonBase>
    ),
  },
  // PayPayキャンペーンバナー
  // {
  //   id: "paypay",
  //   render: ({ classes, onPaypayClick }) => (
  //     <Box onClick={onPaypayClick} className={classes.banner}>
  //       <img className={`${classes.image} ${isMobile ? "" : classes.pcImage}`} src={PaypayBanner} alt="PayPay campaign banner" />
  //     </Box>
  //   ),
  // },
  // ウェビナーバナー
  // {
  //   id: "webinar",
  //   render: ({ classes, onWebinarClick }) => (
  //     <Box onClick={onWebinarClick} className={classes.banner}>
  //       <img className={`${classes.image} ${isMobile ? "" : classes.pcImage}`} src={WebinarBanner} alt="プロパリー限定動画" />
  //     </Box>
  //   ),
  // },
  // SMAULバナー
  {
    id: "smaul",
    render: ({ classes, isMobile, tabIndex, onSmaulClick }) => (
      <ButtonBase tabIndex={tabIndex} onClick={onSmaulClick} className={classes.banner}>
        <img
          className={classes.image}
          src={isMobile ? SmaulBanner : SmaulPcBanner}
          alt="SMAUL"
        />
      </ButtonBase>
    ),
  },
];

const bannerOrder = ["msins", "second_opinion", "smaul", "guide"];
banners.sort((a, b) => bannerOrder.indexOf(a.id) - bannerOrder.indexOf(b.id));

const getLoopBanners = () => {
  if (banners.length <= 1) return banners;
  return [...banners, ...banners, ...banners];
};

interface Props {
  handleOpenModal: () => void;
  onClickTaxReturnBanner: () => void;
  onClickMsinsBanner: () => void;
  onClickCampaignAccept: () => void;
  onClickSecondOpinion: () => void;
  onClickSmaulBanner: () => void;
  onClickWebinarBanner: () => void;
  onClickCozuchiBanner: () => void;
}

const ScrollBanner: React.FC<Props> = ({
  handleOpenModal,
  onClickTaxReturnBanner,
  onClickMsinsBanner,
  onClickCampaignAccept,
  onClickSecondOpinion,
  onClickSmaulBanner,
  onClickWebinarBanner,
  onClickCozuchiBanner,
}) => {
  const classes = useStyles();
  const { isMobile } = useDevice();
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const indexRef = useRef(0);
  const isJumpingRef = useRef(false);
  const isFocusedRef = useRef(false);
  const isAutoScrollingRef = useRef(false);
  const scrollEndTimerRef = useRef<number | null>(null);
  const autoScrollTimerRef = useRef<number | null>(null);
  const autoScrollResumeTimerRef = useRef<number | null>(null);
  const startAutoScrollRef = useRef<() => void>(() => undefined);
  const stopAutoScrollRef = useRef<() => void>(() => undefined);
  const loopBanners = getLoopBanners();
  const getCenteredLeft = useCallback(
    (container: HTMLElement, element: HTMLElement) => {
      return isMobile ? element.offsetLeft : element.offsetLeft - (container.clientWidth - element.offsetWidth) / 2;
    },
    [isMobile]
  );
  const jumpToIndex = useCallback(
    (container: HTMLElement, targetIndex: number) => {
      const targetElement = container.children[targetIndex] as HTMLElement | undefined;
      if (!targetElement) return;
      isJumpingRef.current = true;
      const targetLeft = getCenteredLeft(container, targetElement);
      container.scrollTo({ left: Math.max(0, targetLeft), behavior: "auto" });
      indexRef.current = targetIndex;
      setActiveIndex(targetIndex % banners.length);
      requestAnimationFrame(() => {
        isJumpingRef.current = false;
      });
    },
    [getCenteredLeft]
  );

  const getLoopIndices = useCallback(() => {
    const realCount = banners.length;
    const baseIndex = realCount;
    return {
      realCount,
      baseIndex,
    };
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const { realCount, baseIndex } = getLoopIndices();
    if (realCount <= 1) return;

    const jumpToBase = () => {
      const baseElement = el.children[baseIndex] as HTMLElement | undefined;
      if (!baseElement) return;
      const targetLeft = getCenteredLeft(el, baseElement);
      el.scrollTo({ left: Math.max(0, targetLeft), behavior: "auto" });
      indexRef.current = baseIndex;
    };

    jumpToBase();

    const tick = () => {
      const nextIndex = indexRef.current + 1;
      const nextElement = el.children[nextIndex] as HTMLElement | undefined;
      if (!nextElement) return;
      const targetLeft = getCenteredLeft(el, nextElement);
      isAutoScrollingRef.current = true;
      el.scrollTo({ left: Math.max(0, targetLeft), behavior: "smooth" });
      indexRef.current = nextIndex;
    };

    // 2秒間隔で自動スクロール
    const startAutoScroll = () => {
      if (autoScrollTimerRef.current || isFocusedRef.current) return;
      autoScrollTimerRef.current = window.setInterval(tick, 2000);
    };
    const stopAutoScroll = () => {
      if (autoScrollTimerRef.current) {
        window.clearInterval(autoScrollTimerRef.current);
        autoScrollTimerRef.current = null;
      }
    };
    startAutoScrollRef.current = startAutoScroll;
    stopAutoScrollRef.current = stopAutoScroll;

    startAutoScroll();
    return () => {
      stopAutoScroll();
    };
  }, [getCenteredLeft, getLoopIndices, jumpToIndex, loopBanners.length]);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const { realCount } = getLoopIndices();
    if (realCount <= 1) return;

    const getCenteredIndex = () => {
      const center = el.scrollLeft + el.clientWidth / 2;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;
      Array.from(el.children).forEach((child, index) => {
        const element = child as HTMLElement;
        const elementCenter = element.offsetLeft + element.offsetWidth / 2;
        const distance = Math.abs(center - elementCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      return closestIndex;
    };

    const normalizeIndex = (currentIndex: number) => {
      if (currentIndex < realCount) return currentIndex + realCount;
      if (currentIndex >= realCount * 2) return currentIndex - realCount;
      return currentIndex;
    };

    const scheduleAutoScrollResume = () => {
      if (autoScrollResumeTimerRef.current) {
        window.clearTimeout(autoScrollResumeTimerRef.current);
      }
      autoScrollResumeTimerRef.current = window.setTimeout(() => {
        // 念の為猶予を持って自動スクロール再開
        startAutoScrollRef.current();
      }, 100);
    };

    const handleScroll = () => {
      if (isJumpingRef.current) return;
      if (!isAutoScrollingRef.current) {
        stopAutoScrollRef.current();
        scheduleAutoScrollResume();
      }
      if (scrollEndTimerRef.current) {
        window.clearTimeout(scrollEndTimerRef.current);
      }
      // 念の為少し猶予を持って近いバナーへジャンプ
      scrollEndTimerRef.current = window.setTimeout(() => {
        const centeredIndex = getCenteredIndex();
        const normalizedIndex = normalizeIndex(centeredIndex);
        if (normalizedIndex !== centeredIndex) {
          jumpToIndex(el, normalizedIndex);
          return;
        }
        indexRef.current = centeredIndex;
        setActiveIndex(centeredIndex % realCount);
        isAutoScrollingRef.current = false;
      }, 80);
    };

    el.addEventListener("scroll", handleScroll);
    return () => {
      el.removeEventListener("scroll", handleScroll);
      if (scrollEndTimerRef.current) {
        window.clearTimeout(scrollEndTimerRef.current);
      }
      if (autoScrollResumeTimerRef.current) {
        window.clearTimeout(autoScrollResumeTimerRef.current);
      }
    };
  }, [getLoopIndices, jumpToIndex, loopBanners.length]);

  useEffect(() => {
    const handleResize = () => {
      const el = scrollRef.current;
      if (!el) return;
      const currentElement = el.children[indexRef.current] as HTMLElement | undefined;
      if (!currentElement) return;
      const targetLeft = getCenteredLeft(el, currentElement);
      el.scrollTo({ left: Math.max(0, targetLeft), behavior: "auto" });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [getCenteredLeft]);

  return (
    <Box
      id="top-tour-step1"
      onFocusCapture={() => {
        isFocusedRef.current = true;
        stopAutoScrollRef.current();
      }}
      onBlurCapture={(event: React.FocusEvent<HTMLDivElement>) => {
        if (!event.currentTarget.contains(event.relatedTarget as Node | null)) {
          isFocusedRef.current = false;
          startAutoScrollRef.current();
        }
      }}
    >
      <div
        ref={scrollRef}
        className={`${classes.scrollContainer} ${isMobile ? classes.spRail : classes.pcRail}`}
        aria-label="お知らせ・キャンペーン"
      >
        {loopBanners.map((banner, index) => {
          const actions = {
            classes,
            isMobile,
            tabIndex: index >= banners.length && index < banners.length * 2 ? 0 : -1,
            onPaypayClick: onClickCampaignAccept,
            onSecondOpinionClick: onClickSecondOpinion,
            onGuideClick: handleOpenModal,
            onMsinsClick: onClickMsinsBanner,
            onSmaulClick: onClickSmaulBanner,
            onTaxReturnClick: onClickTaxReturnBanner,
            onWebinarClick: onClickWebinarBanner,
            onCozuchiClick: onClickCozuchiBanner,
          };

          return (
            <Box
              key={`${banner.id}-${index}`}
              className={classes.bannerItem}
              style={{ width: isMobile ? 280 : "100%" }}
            >
              {banner.render(actions)}
            </Box>
          );
        })}
      </div>
      {!isMobile && (
        <Box className={classes.dots}>
          {banners.map((banner, index) => (
            <ButtonBase
              key={banner.id}
              className={classes.dotButton}
              aria-label={`お知らせ ${index + 1}を表示`}
              aria-pressed={activeIndex === index}
              onClick={() => {
                if (scrollRef.current) jumpToIndex(scrollRef.current, banners.length + index);
              }}
            >
              <span className={`${classes.dot} ${activeIndex === index ? classes.activeDot : ""}`} />
            </ButtonBase>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default ScrollBanner;
